import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { BehaviorSubject, filter, first, Subject, take, takeUntil } from 'rxjs';
import { LgvPricingModel } from '../../models/pricing.model';
import { LgvClientService } from '../../../../core/core.module';
import { LgvLoanApp } from '../../../../data-models/lgv-loan-application.model';
import { LgvModel } from '../../../../data-models/longevity.model';
import { LgvLoanApplicationService } from '../../../../core/services/lgv-loan-application.service';
import { LgvPricingScenarioService } from '../../../../core/services/pricing-scenario.service';
import { LgvPricingService } from '../../services/pricing.service';
import { LoanAppPageService } from '../../../../core/services/page-services/loan-app-page.service';

@Component({
    selector: 'lgv-pricing-quotes-card-list',
    templateUrl: './pricing-quotes-card-list.component.html',
    styleUrls: ['./pricing-quotes-card-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PricingQuotesCardListComponent implements OnInit {
    @Input() showLoanFilter = true;
    @Input() fromLoanApp = false;
    viewArchivedLoansCtrl = new FormControl(false);
    allPricingScenarios$ = new BehaviorSubject<
        LgvPricingModel.PricingScenario[]
    >(null);
    filteredPricingScenarios$ = new BehaviorSubject<
        LgvPricingModel.PricingScenario[]
    >(null);
    loanApplications$ = new BehaviorSubject<LgvLoanApp.LoanApplicationDetail[]>(
        []
    );
    opportunities$ = new BehaviorSubject<LgvModel.Opportunity[]>(null);

    onDestroy$ = new Subject();

    currentDate = new Date();
    constructor(
        public lgvClientSvc: LgvClientService,
        private lgvLoanAppSvc: LgvLoanApplicationService,
        public lgvPricingService: LgvPricingService,
        private loanAppPageSvc: LoanAppPageService
    ) {}

    ngOnInit(): void {
        this.lgvClientSvc.SnapShot$.pipe(
            filter(f => !!f),
            takeUntil(this.onDestroy$)
        ).subscribe(ss => {
            this.fetchLoanApplications(ss);
        });

        this.lgvClientSvc.allOpportunities$
            .pipe(
                filter(f => !!f && f.length > 0),
                takeUntil(this.onDestroy$)
            )
            .subscribe(opportunities => {
                /*turning off the expansion of the first opportunity for now*/

                //let isFirst = true;
                //for (let o of opportunities) {
                //    o.isSelected = isFirst;
                //    isFirst = false;
                //}

                this.opportunities$.next(opportunities);
            });

        this.lgvClientSvc.pricingScenarios$
            .pipe(
                filter(f => !!f),
                takeUntil(this.onDestroy$)
            )
            .subscribe(x => {
                this.allPricingScenarios$.next(x);
                this.filteredPricingScenarios$.next(x);
            });

        if (this.fromLoanApp) {
            this.loanAppPageSvc.selectedLoanApplication$
                .pipe(takeUntil(this.onDestroy$))
                .subscribe(la => {
                    const loanScenarios = this.allPricingScenarios$?.value?.filter(
                        ps => ps?.loanApplicationId == la?.id
                    );
                    this.filteredPricingScenarios$.next(loanScenarios);
                });
        }
    }

    downPaymentAmt(ps: LgvPricingModel.PricingScenario): number {
        return (
            ps?.request?.propertyInformation?.appraisedValue -
            ps?.request?.loanInformation?.baseLoanAmount
        );
    }

    downPaymentPct(ps: LgvPricingModel.PricingScenario): number {
        return (
            (this.downPaymentAmt(ps) /
                ps?.request?.propertyInformation?.appraisedValue) *
            100
        );
    }
    fetchLoanApplications(ss) {
        if (!this?.showLoanFilter) {
            return;
        }
        this.lgvLoanAppSvc
            .fetchLoanApplications(ss?.clientInfo?.id)
            .pipe(first())
            .subscribe(la => {
                if (!this.showLoanFilter) return;
                let viewAllLoans = [
                    {
                        loanInfo: {
                            loanNumber: 'View All Loans'
                        }
                    } as LgvLoanApp.LoanApplicationDetail
                ];
                this.loanApplications$.next(viewAllLoans.concat(la?.value));
            });
    }

    filterByLoanId(loan) {
        let filteredByLoan;
        if (!loan?.value?.id) {
            filteredByLoan = this.allPricingScenarios$?.value;
        } else {
            filteredByLoan = this.allPricingScenarios$?.value?.filter(
                ps => ps?.loanApplicationId == loan?.value?.id
            );
        }

        this.filteredPricingScenarios$.next(filteredByLoan);
    }

    refreshScenarios(shouldRefresh: boolean) {
        if (shouldRefresh) {
            this.lgvClientSvc.loadScenarios();
        }
    }
}
